<!--
  navItem "Auszahlungen pro Monat" — QL aggregation (SUM per month) as chart and table.
-->
<div class="cp-provision-agent-payouts">

    @if (!initialized) {

        <p-skeleton height="18rem"></p-skeleton>

    } @else if (!provisionAgentId) {

        <p-message severity="info" text="Kein Abrechnungskonto ausgewählt." styleClass="w-full"></p-message>

    } @else {

        @if (payoutsChartWidget) {
            <div class="mb-3">
                <mvs-widget [widgetData]="payoutsChartWidget"></mvs-widget>
            </div>
        }

        @if (payoutsTableWidget) {
            <mvs-widget [widgetData]="payoutsTableWidget"></mvs-widget>
        }

    }

</div>
